// Author liang gang qiang
// Date 2021-11-25 16:25:20

class MintalMesPrdCraftEnergyConfig {
constructor({
        id = null,
        craftId = '',
        craftName = '',
        energyId = '',
        mstEnergyName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.craftId = craftId;
    this.craftName = craftName;
    this.energyId = energyId;
    this.mstEnergyName = mstEnergyName;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdCraftEnergyConfig();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'craftName',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.grid.craftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstEnergyCode',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.grid.mstEnergyCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstEnergyName',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.grid.mstEnergyName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    craftIdFilter : '',
    craftNameFilter : '',
    energyIdFilter : '',
    mstEnergyNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'craftNameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.filter.craftName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"craftId": "id"}'
                }
        },
        {
        key: 'mstEnergyNameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.filter.mstEnergyName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstEnergy'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"energyId": "id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'craftName',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.entity.craftName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"craftId": "id"}'
                }
        },
        {
        key: 'mstEnergyName',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.entity.mstEnergyName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstEnergy'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"energyId": "id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraftEnergyConfig.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdCraftEnergyConfig, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
